<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <view-section
    title="Collections with this mod"
    :padding-y="false"
    panel-loading
  >
    <div
      class="tw-flex tw-items-center tw-justify-between tw-py-2.5 tw-border-b tw-border-theme-2 last:tw-border-b-0 tw-space-x-2"
    >
      <div class="tw-flex tw-items-center tw-space-x-2">
        <div class="tw-h-8 tw-w-16 mod-global--border-radius tw-bg-theme-1" />
        <loading-label />
      </div>

      <div class="tw-flex tw-space-x-3">
        <div class="tw-size-5 tw-rounded tw-bg-theme-1"></div>
      </div>
    </div>
  </view-section>
</template>
<script>
import LoadingLabel from '@components/Loading/LoadingLabel.vue'
import ViewSection from '@components/View/ViewSection.vue'
export default {
  components: {
    LoadingLabel,
    ViewSection,
  },
}
</script>
